import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";
import { removeEmpty } from "../utils/objectUtils";

export async function getDecksStatusList(parameters: any) {
  let res =  {
    generatedAt: "",
    itens: [
      {
        total: {
          gameId: "",
          form: "",
          title: "",
          openedTime: "",
          serial: "",
          tickets: "",
          payout: "",
          totalTicketCost: "",
          totalTicketPrizes: "",
          currentTotalWager: "",
          currentTotalWon: "",
          actualPayout: "",
          prizesWon: "",
          remainingTicketPct: "",
          inventoryLeft: ""
        },
        location: {
          locationId: 0,
          locationName: ""
        },
        games: [{
          gameId: "",
          form: "",
          title: "",
          openedTime: "",
          serial: "",
          tickets: "",
          payout: "",
          totalTicketCost: "",
          totalTicketPrizes: "",
          currentTotalWager: "",
          currentTotalWon: "",
          actualPayout: "",
          prizesWon: "",
          remainingTicketPct: "",
          inventoryLeft: ""
        }],
      }
    ]
  }
  

  const params = removeEmpty(parameters)
  
  await Api.get(endpoints.getDecksStatusList, { params }).then((response) => {
    if (response.status === 200) {
      if (response.data.error) {
        notificationError(`${response.data.error}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get deck status list')
    }
  }).catch((err: string) => {
    notificationError('Could not get deck status list')
  })

  return res
}

export async function closeDecks (params: any) {
  let res = false
  await Api.post(endpoints.closeDecks, params).then((response) => {
    if (response.status === 200) {
      if (response.data.error) {
        notificationError(`${response.data.error}`)
      } else {
        res = true
        notificationSucces('Decks closed successfully')
      }
    } else {
      notificationError('Could not close decks')
    }
  }).catch((err: string) => {
    notificationError('Could not close decks')
  })
  return res
}